<template>
  <div class="loading" v-if="loading">
    <loading />
  </div>
  <line-chart
    v-else
    height="300px"
    :prop-map="propMap"
    :view-model="data"
    :tooltip-formater="tooltipRender"
    tooltip-class="cust-line-chart-tooltip"
  />
</template>
<script>
import { ListMonthCustomer } from '../services'
import LineChart from '@/components/LineChart.vue'
import Loading from '@/components/Loading.vue'
import _ from 'lodash'
import moment from 'moment'
export default {
  name: 'CustomerLineChart',
  props: {
    timeSpan: {
      type: Object,
      default () {
        return {
          range: null,
          rangeType: 'daterange'
        }
      }
    }
  },
  components: { LineChart, Loading },
  data () {
    return {
      loading: true,
      data: [],
      propMap: {
        xAxis: 'period',
        active: '活跃',
        partBuy: '购买配件',
        serviceBuy: '购买服务',
        register: '新增注册'
      }
    }
  },
  computed: {
    startDay () {
      if (this.timeSpan.range) {
        return moment(this.timeSpan.range[0]).format('YYYY-MM-DD')
      }
      return undefined
    },
    endDay () {
      if (this.timeSpan.range) {
        return moment(this.timeSpan.range[1]).format('YYYY-MM-DD')
      }
      return undefined
    },
    periodType () {
      return this.timeSpan.rangeType === 'daterange' ? 1 : 0
    }
  },
  watch: {
    periodType () {
      this.loadDataDebounce()
    },
    startDay () {
      this.loadDataDebounce()
    },
    endDay () {
      this.loadDataDebounce()
    },
    newAdd () {
      this.loadDataDebounce()
    },
    area () {
      this.loadDataDebounce()
    }
  },
  created () {
    this.loadDataDebounce = _.debounce(() => {
      this.loadData()
    }, 30)
  },
  mounted () {
    this.loadDataDebounce()
  },
  methods: {
    loadData () {
      this.loading = true
      ListMonthCustomer({
        newAdd: this.newAdd,
        startDay: this.startDay,
        endDay: this.endDay,
        dayPeriod: this.periodType === 1,
        area: this.area || undefined
      }).then(resp => {
        this.data = resp
      }).finally(() => {
        this.loading = false
      })
    },
    tooltipRender (params, ticket) {
      const rowItems = params.map(element => {
        return `
        <div class="serie-item">
          <div style="--serie-color:${element.color}">
            <div class="serie-color-block"></div>
          </div>
          <div>${element.seriesName}</div>
          <div>${element.data}</div>
        </div>
        `
      })
      return `
<div>
  <div class="date">${params[0].axisValue}</div>
  ${rowItems.join('')}
</div>
      `
    }
  }
}
</script>
